import { render, staticRenderFns } from "./EditViewTermReportsStudentDetails.vue?vue&type=template&id=6263ecc2&scoped=true"
import script from "./EditViewTermReportsStudentDetails.vue?vue&type=script&lang=js"
export * from "./EditViewTermReportsStudentDetails.vue?vue&type=script&lang=js"
import style0 from "./EditViewTermReportsStudentDetails.vue?vue&type=style&index=0&id=6263ecc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6263ecc2",
  null
  
)

export default component.exports